import React, { useContext } from 'react'
import NewFillButton from '../Core/NewFillButton'
import FlexView from 'react-flexview/lib'
import { useForm, useFieldArray } from 'react-hook-form';
import { TextField, InputAdornment, Container } from '@material-ui/core';
import AddBoxIcon from '@material-ui/icons/AddBox';
import CloseIcon from '@material-ui/icons/Close';
import { SessionService } from '../../services/SessionService';
import { SessionContextStore } from '../../context/SessionContext';
import { InsurancePurchaseContextStore } from '../../context/InsuracePurchaseContext';
import InsuranceApi from '../../api/insurance.api';
import { awaitWithLoading } from '../../services/utils';
import { EventEmitterService, EventKey } from '../../services/EventEmitterService';
import { BuyingInsuranceContextStore } from '../../context/BuyingInsuranceContext';
import DataLayerService from '../../services/DataLayerService';
import { EMAIL_REGEX } from '../../Constants';

export const GetAQuoteForm = ({close}) => {
    const sessionContext = useContext(SessionContextStore)
    const insurancePurchaseContext = useContext(InsurancePurchaseContextStore)
    const offersContext = useContext(BuyingInsuranceContextStore)

    const { control, register, getValues, triggerValidation, errors } = useForm({mode: 'onChange', defaultValues: { emails: [
        SessionService.isLoggedIn() ? sessionContext.user.email : ''
    ] } });
    const { fields, append, remove } = useFieldArray({control, name: "emails"});

    const sendQuote = async () => {
        let valid = await triggerValidation()
        if(!valid) return

        let res = await awaitWithLoading(InsuranceApi.sendAQuote(insurancePurchaseContext, offersContext,
            fields.map((i, index) => getValues()[`emails[${index}]`]), getValues()['company_name']))
        if(res.ok) {
            EventEmitterService.dispatch(EventKey.ShowSuccess, { title: 'The quote has been sent by email', onClose: close})
            DataLayerService.pushToDataLayer({event: 'quote sent successfuly'})
        }
        else {
            if(res.data && res.data.messages && res.data.messages.approval_required) {
                EventEmitterService.dispatch(EventKey.ShowError, {res: res, closeBelowAction: true, actionText: 'Refer', onClose: async (btnId) => {
                    if(btnId == 1) {
                        let res2 = await awaitWithLoading(InsuranceApi.referQuote(insurancePurchaseContext, offersContext))
                        if(res2.ok) {
                            close && close()
                            EventEmitterService.dispatch(EventKey.ShowSuccess, {title: 'Refer request sent successfuly'})
                        }
                        else 
                            EventEmitterService.dispatch(EventKey.ShowError, res2)
                    }
                }})
            }
            else {
                EventEmitterService.dispatch(EventKey.ShowError, res)
            }
        }
    }

    const addEmailAddress = () => {
        append('')
    }

    const removeEmail = (index) => {
        remove(index)
    }

    return (
        <React.Fragment>
        <div className="text-title blue textcenter">Where should we send the quote?</div>
        <Container maxWidth="sm" className='margin-bottom-basic'>
            <div>
                {fields.map((field, index) => {
                    return <TextField key={field.id} variant="outlined" 
                            className="margin-top-basic" 
                            label="Email" 
                            type="email"
                            error={!!errors.emails && !!errors.emails[index]}
                            fullWidth
                            name={`emails[${index}]`} 
                            InputProps={index >= 1 ? {endAdornment: <InputAdornment> <CloseIcon onClick={() => removeEmail(index)} className="powderblue clickable" fontSize="small" /></InputAdornment>} : undefined}
                            inputRef={register({required: true, pattern: { value: EMAIL_REGEX, message: "invalid email address"}})} /> })}

                <FlexView vAlignContent={'center'} className="clickable margin-top-basic">
                    <AddBoxIcon onClick={addEmailAddress} className="blue clickable" />
                    <div onClick={addEmailAddress} className="text-small blue margin-left-6 clickable">Add another email</div>
                </FlexView>
                
                <TextField fullWidth variant="outlined" className="clickable margin-top-basic" label="Name / Company name" name="company_name" inputRef={register}/>
                
                <div className="text-small bluegrey margin-top-6">This name will appear on the quote</div>
                <NewFillButton
                    onClick={sendQuote}>Send quote</NewFillButton>
                </div>
            </Container>
        </React.Fragment>           
    )
}